



































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ProgramMedia extends Vue {
  @Prop({ type: Array, default: () => [] }) images!: string[];
  @Prop({ type: String, default: "" }) video!: string;
  @Prop({ type: Boolean, default: false }) videoFirst!: boolean;
  @Prop({ type: Boolean, default: false }) cover!: boolean;

  selected: number = 0;

  get items(): any[] {
    const images = this.images.map((url) => ({ url: url, video: false }));
    const video = this.video ? [{ url: this.video, video: true }] : [];
    return this.videoFirst ? video.concat(images) : images.concat(video);
  }

  get current(): any {
    return this.items[this.selected];
  }

  select(index: number) {
    this.selected = index;
    if (this.items[index].video) {
      this.$nextTick(() => (this.$refs.video as HTMLVideoElement).play());
    }
  }
}
